
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="60.8" height="32pt" viewBox="0 0 45.6 32"><path d="M38.133 30.805c6.836 5.46 11.215-10.852.324-13.86C29.32 14.41 20.125 18.754 10.91 28.88c0 0 17.02-6.223 27.223 1.926Zm0 0" style="stroke:none;fill-rule:nonzero;fill:#404040;fill-opacity:1"/><path d="M11.063 28.746C17.608 21.95 28.5 14.375 38.648 17.172c2.36.668 4.036 2.039 5.122 3.676L34.172 1.484C32.8-.703 29.3-.246 27.32 1.43L1.96 22.676c-2.304 1.976-2.437 5.5-.304 7.633a5.199 5.199 0 0 0 6.95.378Zm0 0" style="stroke:none;fill-rule:nonzero;fill:#828282;fill-opacity:1"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    